import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { ApContentService } from '@ap/content';

import content from './error.content.json';
import { ErrorContext } from './error.model';

/**
 * @ngdoc component
 * @name ErrorComponent
 * @module ErrorModule
 */
@Component({
    selector: 'klant-login-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss'],
    standalone: false
})
export class ErrorComponent implements OnInit {
    @Input()
    public context: ErrorContext = ErrorContext.ERROR;

    @Output()
    public actionClicked = new EventEmitter<void>();

    public constructor(private readonly contentService: ApContentService) {}

    public ngOnInit(): void {
        this.contentService.addContentItems(content);
    }

    public doAction(): void {
        this.actionClicked.emit();
    }

    public showLoginButton(): boolean {
        return this.context === ErrorContext.ERROR;
    }
}
